<template>
  <div>
    <b-card title="نقش جدید">
      <b-card-text>
        <div>
          <b-form @submit="onSubmit" v-if="show">
            <b-row>
              <b-col>
                <b-form-group id="input-group-2" label="نام نقش:" label-for="input-2">
                  <b-form-input
                    id="input-2"
                    v-model="form.name"
                    required
                    placeholder="نام نقش را وارد کنید"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-table responsive striped :items="form.Menus" :fields="MenuFields">
                <template v-slot:cell(on_list)="data">
                  <b-form-checkbox v-model="data.item.on_list"></b-form-checkbox>
                </template>
                <template v-slot:cell(on_create)="data">
                  <b-form-checkbox v-model="data.item.on_create"></b-form-checkbox>
                </template>
                <template v-slot:cell(on_edit)="data">
                  <b-form-checkbox v-model="data.item.on_edit"></b-form-checkbox>
                </template>
                <template v-slot:cell(on_delete)="data">
                  <b-form-checkbox v-model="data.item.on_delete"></b-form-checkbox>
                </template>
              </b-table>
            </b-row>

            <b-button type="submit" variant="primary">ذخیره</b-button>
            <b-button href="#/roles" variant="danger">بازگشت</b-button>
          </b-form>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";

export default {
  name: "addUser",
  data() {
    return {
      form: {
        name: "",
        Menus: []
      },
      roles: [],
      show: true,
      MenuFields: [
        {
          key: "title",
          label: "عنوان"
        },
        {
          key: "on_list",
          label: "نمایش لیست"
        },
        {
          key: "on_create",
          label: "جدید"
        },
        {
          key: "on_edit",
          label: "ویرایش"
        },
        {
          key: "on_delete",
          label: "حذف"
        }
      ]
    };
  },
  created() {
    //var id = this.$route.params.id;

    httpHelpoer.getData("role/defaultMenus").then(res => {
      this.form.Menus = res.result.map(element => {
          return {
            menu_id:element.id,
            title: element.title,
            url: element.url,
            on_list: false,
            on_create: false,
            on_edit: false,
            on_delete: false
          };
        });
    });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      httpHelpoer.postData("role", this.form).then(res => {
        this.$router.push("/rp/2")
      });
    }
  },
  mounted() {
   
    this.$store.dispatch(SET_BREADCRUMB, [
      {
         title: "نقش",
        route: "/rp/2",
      },
      {
        title: "نقش جدید",
      },
    ]);
  },
};
</script>